<template>
  <div class="page">
    <div class="left-panel">
      <div class="brand">
        <div class="brand-logo">
          <i class="fa fa-star"></i>
        </div>
        <div class="brand-name">Dream Days</div>
        <div class="brand-sub">Admin Panel</div>
      </div>
      <div class="left-footer">
        <p>© 2025 Dream Days. All rights reserved.</p>
      </div>
    </div>

    <div class="right-panel">
      <div class="form-box">
        <div class="form-title">Welcome back</div>
        <div class="form-sub">Sign in to your admin account</div>

        <div class="error-box" v-show="hasErrors">
          <i class="fa fa-exclamation-circle"></i>
          User not found. Please check your credentials.
        </div>

        <b-form @submit="onSubmit">
          <div class="field">
            <label>Email address</label>
            <input type="email" v-model="form.email" placeholder="admin@dreamdays.com" required />
          </div>
          <div class="field">
            <label>Password</label>
            <input type="password" v-model="form.password" placeholder="••••••••" required />
          </div>
          <button type="submit" class="btn-login">
            <i class="fa fa-sign-in"></i> Sign in
          </button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import * as Helpers from "../../helpers";
import axios from "axios";

export default {
  data() {
    return {
      form: { email: "", password: "", guard: "admin" },
      hasErrors: false,
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.hasErrors = false;
      axios
          .post(Helpers.config("BACKEND_ROOT") + "/v2/auth/login", this.form)
          .then((response) => {
            this.$cookies.set("dd-access-token", response.data.data.access_token);
            this.$cookies.set("dd-refresh-token", response.data.data.refresh_token);
            location.href = "/";
          })
          .catch(() => { this.hasErrors = true; });
    },
  },
};
</script>

<style scoped>
* { box-sizing: border-box; }

.page {
  display: flex;
  min-height: 100vh;
  background: #0a0a0f;
  font-family: 'Inter', sans-serif;
}

.left-panel {
  width: 380px;
  background: #f42f4b;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}
.left-panel::before {
  content: '';
  position: absolute;
  width: 350px; height: 350px;
  border-radius: 50%;
  background: rgba(255,255,255,0.06);
  bottom: -100px; right: -100px;
}
.left-panel::after {
  content: '';
  position: absolute;
  width: 200px; height: 200px;
  border-radius: 50%;
  background: rgba(255,255,255,0.06);
  top: 50px; right: 40px;
}

.brand-logo {
  width: 48px; height: 48px;
  background: rgba(255,255,255,0.2);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 1rem;
}
.brand-logo i { color: #fff; font-size: 22px; }
.brand-name { color: #fff; font-size: 22px; font-weight: 600; }
.brand-sub { color: rgba(255,255,255,0.6); font-size: 13px; margin-top: 4px; }
.left-footer p { color: rgba(255,255,255,0.4); font-size: 12px; position: relative; z-index: 2; }

.right-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
}

.form-box { width: 100%; max-width: 360px; }

.form-title { color: #fff; font-size: 24px; font-weight: 600; margin-bottom: 6px; }
.form-sub { color: #666; font-size: 14px; margin-bottom: 2rem; }

.field { margin-bottom: 1.1rem; }
.field label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #888;
  margin-bottom: 6px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}
.field input {
  width: 100%;
  height: 46px;
  background: #141418;
  border: 1px solid #222;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  padding: 0 14px;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
}
.field input::placeholder { color: #444; }
.field input:focus { border-color: #f42f4b; background: #18181e; }

.error-box {
  background: rgba(244,47,75,0.1);
  border: 1px solid rgba(244,47,75,0.3);
  border-radius: 10px;
  padding: 12px 14px;
  color: #f88;
  font-size: 13px;
  margin-bottom: 1.2rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-login {
  width: 100%;
  height: 46px;
  background: #f42f4b;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.1s;
}
.btn-login:hover { background: #d62640; }
.btn-login:active { transform: scale(0.98); }

@media (max-width: 768px) {
  .page { flex-direction: column; }
  .left-panel { width: 100%; padding: 2rem; }
  .left-footer { display: none; }
}
</style>